<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">

    export const EmbedDefaults = {
        "name": "embed",

        "outer-container": { 
            "style": {
                "text-align": "center",
                "align-items": "center",
                "z-index": "5",
            }
        },
        "iframe": {
            "name": "iframe",
            "srcdoc": "<h1>HEY!</h1>",
            "style": {
                "width": "100%", 
                "height": "auto", 
                "border-radius": "0px",
                "margin-bottom": "10px"
            },
            "src": "https://i.pinimg.com/originals/40/ab/e3/40abe3f1c51895079d447397badbbf64.png"
        },
        "meta": {
            "order": {
                "iframe": 1,
            }
        }
    }
    
</script>

<script>


</script>


<svelte:head>
    <script src="https://apps.elfsight.com/p/platform.js" defer></script> 
</svelte:head>
        
<div class="elfsight-app-95e4144d-d58d-44a3-b02f-2e37e2883be7"></div>

<style> 

</style>